export function getXMLParser() {
    let parseXml;
    const win = window as any;
    if (typeof win.DOMParser !== 'undefined') {
        parseXml = (xmlStr: string) => {
            return new win.DOMParser().parseFromString(xmlStr, 'text/xml');
        };
    } else if (typeof win.ActiveXObject !== 'undefined' && new win.ActiveXObject('Microsoft.XMLDOM')) {
        parseXml = (xmlStr: string) => {
            const xmlDoc = new win.ActiveXObject('Microsoft.XMLDOM');
            xmlDoc.async = 'false';
            xmlDoc.loadXML(xmlStr);
            return xmlDoc;
        };
    } else {
        throw new Error('No XML parser found');
    }

    return {
        parseXml
    };
}


export function mergeXlf(source: any, target: any) {
    if(!source){
        return target;
    }
    const parser = getXMLParser();
    const sourceTree = parser.parseXml(source);
    const targetTree = parser.parseXml(target);
    const translationUnits = targetTree.documentElement.getElementsByTagName('trans-unit');
    const parseErrors = targetTree.documentElement.getElementsByTagName('parsererror');

    if (parseErrors && parseErrors.length) {
        console.error(
            'Error while parsing target XLF files! [mergeXlf]',
            Array.from(parseErrors).join(','),
            targetTree.documentElement
        );
    }
    for (let i = 0; i < translationUnits.length; i++) {
        const id = translationUnits[i].getAttribute('id');
        const selector = 'trans-unit[id="' + id + '"]';
        const sourceElement = sourceTree.documentElement.querySelector(selector);
        if (sourceElement) {
            sourceTree.documentElement
                .getElementsByTagName('body')[0]
                .replaceChild(translationUnits[i].cloneNode(true), sourceTree.documentElement.querySelector(selector));
        } else {
            sourceTree.documentElement.getElementsByTagName('body')[0].appendChild(translationUnits[i].cloneNode(true));
        }
    }
    const serializer = new XMLSerializer();
    let serialized;
    try {
        serialized = serializer.serializeToString(sourceTree);
    } catch (e) {
        console.error('Error while serialising XLF file! [mergeXlf]', e, sourceTree);
    }
    return serialized;
}
